module.exports = __webpack_public_path__ + "media/Steven.2982c78b.mp4";